import { GlideDepositConfigContextType } from "./useDepositConfig";

export function getETA(etaInSeconds: number | undefined = 0) {
  const isHours = etaInSeconds >= 3600;
  const isMinutes = etaInSeconds >= 60 && etaInSeconds < 3600;

  let timeValue: number;
  let timeUnit: string;

  if (isHours) {
    timeValue = Math.floor(etaInSeconds / 3600);
    timeUnit = timeValue === 1 ? "hour" : "hours";
  } else if (isMinutes) {
    timeValue = Math.floor(etaInSeconds / 60);
    timeUnit = timeValue === 1 ? "min" : "mins";
  } else {
    timeValue = Math.floor(etaInSeconds);
    timeUnit = timeValue === 1 ? "sec" : "secs";
  }

  return `${timeValue} ${timeUnit}`;
}

export function getETAWarning(
  mode: GlideDepositConfigContextType["mode"],
  etaInSeconds: number | undefined,
) {
  if (!mode || !etaInSeconds || etaInSeconds <= 10) {
    return null;
  }

  const isHours = etaInSeconds >= 3600;
  const isMinutes = etaInSeconds >= 60 && etaInSeconds < 3600;

  let timeValue: number;
  let timeUnit: string;

  if (isHours) {
    timeValue = Math.floor(etaInSeconds / 3600);
    timeUnit = timeValue === 1 ? "hour" : "hours";
  } else if (isMinutes) {
    timeValue = Math.floor(etaInSeconds / 60);
    timeUnit = timeValue === 1 ? "min" : "mins";
  } else {
    timeValue = Math.floor(etaInSeconds);
    timeUnit = timeValue === 1 ? "second" : "seconds";
  }

  const message =
    mode === "call" || mode === "pay"
      ? `It can take up to ${timeValue} ${timeUnit} for your transaction to process.`
      : `It can take up to ${timeValue} ${timeUnit} for your funds to be available.`;

  return message;
}
